import { styled } from 'styled-components'
import { XIcon } from '../../icons'
import { withStyles } from '@mui/styles'
import { Drawer as MuiDrawer, Dialog as MuiDialog } from '@mui/material'
import { onMediumScreen, onSmallScreen } from 'mixtiles-web-common'
import Button from 'mixtiles-web-common/ui/Button'

export const BottomDrawer = withStyles({
  root: {
    zIndex: '1500 !important',
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '16px 16px 0 0',
    padding: '34px 0 24px',
    maxHeight: '100%',
  },
})(MuiDrawer)

export const Dialog = withStyles({
  root: {
    zIndex: '1500 !important',
  },
  paper: {
    borderRadius: '16px',
    padding: '60px 0 48px',
  },
})(MuiDialog)

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${onSmallScreen()} {
    min-width: 400px;
  }

  ${onMediumScreen()} {
    width: 380px;
  }
`

export const Title = styled.div`
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
  max-width: 268px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 30px;
`

export const Cta = styled(Button)`
  margin-bottom: 12px;
  min-width: 260px;
`

export const CloseButton = styled(XIcon)`
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  width: 32px;
  height: 32px;
  top: 22px;
  left: 23px;
  position: absolute;
`
